import { Component } from "react";
import { parse } from "querystringify";
import { Paths } from "./../../constants/UrlConstants";
import { RedirectToInternalViewLogin } from "../../helpers/AccountsHelper";
import { withRouter } from "react-router";

export class InternalView extends Component {
  componentDidMount() {
    let params = this.props.location && parse(this.props.location.search);
    if (params && params.id) {
      RedirectToInternalViewLogin(params);
    } else {
      this.props.history && this.props.history.push(Paths.NotFound);
    }
  }

  render() {
    return null;
  }
}

export default withRouter(InternalView);
